// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ni-0";
export var buttonContainer = "_ni-3";
export var cancelButton = "_ni-4";
export var headerSection = "_ni-6";
export var headerTitle = "_ni-9";
export var messageSideLeft = "_ni-1";
export var messageSideRight = "_ni-2";
export var orderNumberContainer = "_ni-7";
export var orderNumberLabel = "_ni-8";
export var submitButton = "_ni-5";